import { computed } from 'vue-demi';
import { Keyword } from '@ilteducation/content-ref-data-types';
import useContentRefData from './use-content-ref-data';
import { getRefData, getRefDatas, Response } from './api';

// It is common enough that referenced keywords do not exist, so we keep track of them to avoid extra requests
const notFoundKeywordKeys = new Set<string>();

const useKeywords = () => {
  const refDataStore = useContentRefData();

  const isLoading = computed(() => refDataStore.isLoading('keywords'));

  const byId = async (id: string) => {
    const loadedKeyword = refDataStore.byId('keywords', id);
    if (loadedKeyword) {
      return loadedKeyword as Keyword;
    }
    return getRefData('keywords', id);
  };
  const byIds = async (ids: string[]) => refDataStore.loadByIds('keywords', ids);

  const byKey = async (key: string) => {
    if (notFoundKeywordKeys.has(key)) {
      return undefined;
    }
    const loadedKeyword: Keyword | undefined = refDataStore
      .all('keywords')
      .map((keyword) => keyword as Keyword)
      .find((keyword) => keyword.key === key);
    if (loadedKeyword) {
      return loadedKeyword;
    }
    const keywords: Keyword[] = [];
    let cursor: string | null = null;
    do {
      // eslint-disable-next-line no-await-in-loop
      const resp: Response<Keyword> = await getRefDatas<Keyword>('keywords', cursor, [{ key: 'key', value: [key] }]);
      keywords.push(...resp.data);
      cursor = resp.cursor;
    } while (cursor);

    const filteredKeywords = keywords.filter((keyword) => keyword.key === key);
    const res = filteredKeywords.length > 0 ? filteredKeywords[0] : undefined;
    if (!res) {
      notFoundKeywordKeys.add(key);
    }
    return res;
  };

  return {
    byId,
    byKey,
    byIds,
    isLoading,
  };
};

export default useKeywords;
